<div class="content-wrapper">


  <!-- Main content -->
  <section class="content">
    <div class="container-fluid" style="padding-top: 20px">
      <!-- Info boxes -->
      <router-outlet></router-outlet>
      <!-- /.row -->

    </div><!--/. container-fluid -->
  </section>
  <!-- /.content -->
</div>
<!-- /.content-wrapper -->
